import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { CheckDuplicate } from 'components/CheckDuplicate';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import { Uploader } from 'components/Uploader';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const UsersEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		username: yup.string().required().label("Username"),
		fullname: yup.string().required().label("Fullname"),
		phonenumber: yup.string().required().label("Phonenumber"),
		address: yup.string().nullable().label("Address"),
		city: yup.string().nullable().label("City"),
		state: yup.string().nullable().label("State"),
		zipcode: yup.string().nullable().label("Zipcode"),
		dateofbirth: yup.string().nullable().label("Dateofbirth"),
		registrationdate: yup.string().nullable().label("Registrationdate"),
		lastlogin: yup.string().nullable().label("Lastlogin"),
		isemailverified: yup.number().nullable().label("Isemailverified"),
		isphoneverified: yup.string().nullable().label("Isphoneverified"),
		isactive: yup.string().nullable().label("Isactive"),
		isadmin: yup.string().nullable().label("Isadmin"),
		loyaltypoints: yup.number().nullable().label("Loyaltypoints"),
		preferredpaymentmethod: yup.string().nullable().label("Preferredpaymentmethod"),
		notes: yup.string().nullable().label("Notes"),
		user_role_id: yup.string().nullable().label("User Role Id"),
		profile_photo: yup.string().nullable().label("Profile Photo"),
		authprovider: yup.string().nullable().label("Authprovider"),
		provideruserid: yup.string().nullable().label("Provideruserid"),
		profilephotourl: yup.string().nullable().label("Profilephotourl"),
		account_number: yup.string().nullable().label("Account Number"),
		ifsc_code: yup.string().nullable().label("Ifsc Code")
	});
	// form default values
	const formDefaultValues = {
		username: '', 
		fullname: '', 
		phonenumber: '', 
		address: '', 
		city: '', 
		state: '', 
		zipcode: '', 
		dateofbirth: new Date(), 
		registrationdate: "(getdate())", 
		lastlogin: new Date(), 
		isemailverified: '', 
		isphoneverified: "((0))", 
		isactive: "((1))", 
		isadmin: "((0))", 
		loyaltypoints: "((0))", 
		preferredpaymentmethod: '', 
		notes: '', 
		user_role_id: '', 
		profile_photo: '', 
		authprovider: "Local", 
		provideruserid: '', 
		profilephotourl: '', 
		account_number: '', 
		ifsc_code: '', 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/users`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="UsersEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Edit User"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Username *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <CheckDuplicate value={formik.values.username} apiPath="components_data/users_username_exist">
                                                { (checker) => 
                                                <>
                                                <InputText name="username" onBlur={checker.check} onChange={formik.handleChange}  value={formik.values.username}   label="Username" type="text" placeholder="Enter Username"        className={inputClassName(formik?.errors?.username)} />
                                                <ErrorMessage name="username" component="span" className="p-error" />
                                                {(!checker.loading && checker.exist) && <small className="p-error">Not available</small>}
                                                {checker.loading && <small className="text-500">Checking...</small> }
                                                </>
                                                }
                                                </CheckDuplicate>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Fullname *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="fullname"  onChange={formik.handleChange}  value={formik.values.fullname}   label="Fullname" type="text" placeholder="Enter Fullname"        className={inputClassName(formik?.errors?.fullname)} />
                                                <ErrorMessage name="fullname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Phonenumber *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="phonenumber"  onChange={formik.handleChange}  value={formik.values.phonenumber}   label="Phonenumber" type="text" placeholder="Enter Phonenumber"        className={inputClassName(formik?.errors?.phonenumber)} />
                                                <ErrorMessage name="phonenumber" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Address 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="address"  onChange={formik.handleChange}  value={formik.values.address}   label="Address" type="text" placeholder="Enter Address"        className={inputClassName(formik?.errors?.address)} />
                                                <ErrorMessage name="address" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                City 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="city"  onChange={formik.handleChange}  value={formik.values.city}   label="City" type="text" placeholder="Enter City"        className={inputClassName(formik?.errors?.city)} />
                                                <ErrorMessage name="city" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                State 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="state"  onChange={formik.handleChange}  value={formik.values.state}   label="State" type="text" placeholder="Enter State"        className={inputClassName(formik?.errors?.state)} />
                                                <ErrorMessage name="state" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Zipcode 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="zipcode"  onChange={formik.handleChange}  value={formik.values.zipcode}   label="Zipcode" type="text" placeholder="Enter Zipcode"        className={inputClassName(formik?.errors?.zipcode)} />
                                                <ErrorMessage name="zipcode" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Dateofbirth 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="dateofbirth" showButtonBar className={inputClassName(formik?.errors?.dateofbirth)} dateFormat="yy-mm-dd" value={formik.values.dateofbirth} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="dateofbirth" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Registrationdate 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="registrationdate" value={formik.values.registrationdate} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.registrationdate)}        />
                                                <ErrorMessage name="registrationdate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Lastlogin 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="lastlogin" value={formik.values.lastlogin} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.lastlogin)}        />
                                                <ErrorMessage name="lastlogin" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Isemailverified 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="isemailverified"  onChange={formik.handleChange}  value={formik.values.isemailverified}   label="Isemailverified" type="number" placeholder="Enter Isemailverified"  min={0}  step="any"    className={inputClassName(formik?.errors?.isemailverified)} />
                                                <datalist id="isemailverified_list">
                                                { app.menus.isactive.map((option, index)=> <option key={index} value={option.value}>{option.label}</option>)}
                                                </datalist>
                                                <ErrorMessage name="isemailverified" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Isphoneverified 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="isphoneverified"  onChange={formik.handleChange}  value={formik.values.isphoneverified}   label="Isphoneverified" type="text" placeholder="Enter Isphoneverified"        className={inputClassName(formik?.errors?.isphoneverified)} />
                                                <ErrorMessage name="isphoneverified" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Isactive 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="isactive"  onChange={formik.handleChange}  value={formik.values.isactive}   label="Isactive" type="text" placeholder="Enter Isactive"        className={inputClassName(formik?.errors?.isactive)} />
                                                <ErrorMessage name="isactive" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Isadmin 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="isadmin"  onChange={formik.handleChange}  value={formik.values.isadmin}   label="Isadmin" type="text" placeholder="Enter Isadmin"        className={inputClassName(formik?.errors?.isadmin)} />
                                                <ErrorMessage name="isadmin" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Loyaltypoints 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="loyaltypoints"  onChange={formik.handleChange}  value={formik.values.loyaltypoints}   label="Loyaltypoints" type="number" placeholder="Enter Loyaltypoints"  min={0}  step="any"    className={inputClassName(formik?.errors?.loyaltypoints)} />
                                                <ErrorMessage name="loyaltypoints" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Preferredpaymentmethod 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="preferredpaymentmethod"  onChange={formik.handleChange}  value={formik.values.preferredpaymentmethod}   label="Preferredpaymentmethod" type="text" placeholder="Enter Preferredpaymentmethod"        className={inputClassName(formik?.errors?.preferredpaymentmethod)} />
                                                <ErrorMessage name="preferredpaymentmethod" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Notes 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="notes"  onChange={formik.handleChange}  value={formik.values.notes}   label="Notes" type="text" placeholder="Enter Notes"        className={inputClassName(formik?.errors?.notes)} />
                                                <ErrorMessage name="notes" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                User Role Id 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/user_role_id_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="user_role_id"     optionLabel="label" optionValue="value" value={formik.values.user_role_id} onChange={formik.handleChange} options={response} label="User Role Id"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.user_role_id)}   />
                                                    <ErrorMessage name="user_role_id" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Profile Photo 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className={inputClassName(formik?.errors?.profile_photo)}>
                                                    <Uploader name="profile_photo" showUploadedFiles value={formik.values.profile_photo} uploadPath="fileuploader/upload/profile_photo" onChange={(paths) => formik.setFieldValue('profile_photo', paths)} fileLimit={1} maxFileSize={3} accept=".jpg,.png,.gif,.jpeg" multiple={false} label="Choose files or drop files here" onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                </div>
                                                <ErrorMessage name="profile_photo" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Authprovider 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="authprovider"  onChange={formik.handleChange}  value={formik.values.authprovider}   label="Authprovider" type="text" placeholder="Enter Authprovider"        className={inputClassName(formik?.errors?.authprovider)} />
                                                <ErrorMessage name="authprovider" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Provideruserid 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="provideruserid"  onChange={formik.handleChange}  value={formik.values.provideruserid}   label="Provideruserid" type="text" placeholder="Enter Provideruserid"        className={inputClassName(formik?.errors?.provideruserid)} />
                                                <ErrorMessage name="provideruserid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Profilephotourl 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className={inputClassName(formik?.errors?.profilephotourl)}>
                                                    <Uploader name="profilephotourl" showUploadedFiles value={formik.values.profilephotourl} uploadPath="fileuploader/upload/profilephotourl" onChange={(paths) => formik.setFieldValue('profilephotourl', paths)} fileLimit={1} maxFileSize={3} accept=".jpg,.png,.gif,.jpeg" multiple={false} label="Choose files or drop files here" onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                </div>
                                                <ErrorMessage name="profilephotourl" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Account Number 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="account_number"  onChange={formik.handleChange}  value={formik.values.account_number}   label="Account Number" type="text" placeholder="Enter Account Number"        className={inputClassName(formik?.errors?.account_number)} />
                                                <ErrorMessage name="account_number" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Ifsc Code 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="ifsc_code"  onChange={formik.handleChange}  value={formik.values.ifsc_code}   label="Ifsc Code" type="text" placeholder="Enter Ifsc Code"        className={inputClassName(formik?.errors?.ifsc_code)} />
                                                <ErrorMessage name="ifsc_code" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label="Update" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
UsersEditPage.defaultProps = {
	primaryKey: 'userid',
	pageName: 'users',
	apiPath: 'users/edit',
	routeName: 'usersedit',
	submitButtonLabel: "Update",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Update Record",
	msgAfterSave: "Record updated successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default UsersEditPage;
